import React from 'react';
import { Tooltip } from '@piwikpro/ui-components';
import { ComponentDowntime, Range } from '../model/ComponentDowntime';
import { Axis } from './Axis';

import './UptimeGraphComponent.css';
import { statusTooltip } from '../helpers';

type UptimeGraphComponentProps = {
  name: string;
  width: number;
  height: number;
  start: Date;
  end: Date;
  downtimes: ComponentDowntime[];
};

export function mkChartData(
  start: number | Date,
  end: number | Date,
  width: number,
  rawData: ComponentDowntime[]
) {
  const startVal = start.valueOf();
  const endVal = end.valueOf();
  return rawData
    .filter((d) => d.downtime.end > start)
    .filter((d) => d.downtime.start < end)
    .map((d) =>
      d.downtime
        .trunc(start, end)
        .asRange()
        .transform(new Range(startVal, endVal), new Range(0, width))
    );
}

const UptimeGraphComponent: React.FC<UptimeGraphComponentProps> = ({
  name,
  width,
  height,
  start,
  end,
  downtimes,
}) => {
  const ownDowntimes = downtimes.filter((d) => d.name === name);
  const info = ownDowntimes.filter((d) => d.severity === 'info');
  const disrupted = ownDowntimes.filter((d) => d.severity === 'disrupted');
  const down = ownDowntimes.filter((d) => d.severity === 'down');

  return (
    <Tooltip content={statusTooltip} title="Legend" position="top">
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <g className="up">
          <rect x="0" y="0" width={width} height={height - 50} />
        </g>
        <g className="info">
          {mkChartData(start, end, width, info).map((d, idx) => (
            <rect
              key={idx + '-info'}
              x={d.start}
              y="0"
              width={d.length()}
              height={height - 50}
            />
          ))}
        </g>
        <g className="disrupted">
          {mkChartData(start, end, width, disrupted).map((d, idx) => (
            <rect
              key={idx + '-disrupted'}
              x={d.start}
              y="0"
              width={d.length()}
              height={height - 50}
            />
          ))}
        </g>
        <g className="down">
          {mkChartData(start, end, width, down).map((d, idx) => (
            <rect
              key={idx + '-down'}
              x={d.start}
              y="0"
              width={d.length()}
              height={height - 50}
            />
          ))}
        </g>
        <Axis start={start} end={end} width={width} height={height} />
      </svg>
    </Tooltip>
  );
};

export { UptimeGraphComponent };
